var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOrganization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E5F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 27.9143H29.0039",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7834 17.7734V27.9077",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 21H24.0017V24.0013H22.0009",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5839 17.7796C21.1569 17.7796 20.0001 16.6228 20.0001 15.1958C20.0001 16.6231 18.843 17.7801 17.4158 17.7801C15.9885 17.7801 14.8315 16.6231 14.8315 15.1958C14.8294 16.6213 13.6732 17.7757 12.2477 17.7756V17.7756C11.4648 17.7756 10.7381 17.3689 10.3286 16.7017C9.91914 16.0344 9.88568 15.2023 10.2402 14.5043L11.9765 11.0869C12.3178 10.4153 13.0073 9.99219 13.7607 9.99219H26.2394C26.9928 9.99219 27.6824 10.4153 28.0236 11.0869L29.7599 14.5044C30.1144 15.2024 30.0809 16.0344 29.6715 16.7017C29.262 17.3689 28.5353 17.7756 27.7525 17.7756V17.7756V17.7796V17.7796C27.0672 17.7796 26.41 17.5074 25.9254 17.0229C25.4409 16.5383 25.1686 15.8811 25.1687 15.1958C25.1664 16.6216 24.0097 17.7761 22.5839 17.7756",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99609 23.5007V27.0022C9.99609 27.9691 10.78 28.7528 11.7468 28.7529H17.2491C18.216 28.7528 18.9998 27.9691 18.9998 27.0022V23.5007C18.9998 22.5339 18.216 21.7501 17.2491 21.75H11.7468C10.78 21.7501 9.99609 22.5339 9.99609 23.5007V23.5007Z",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 24.8596H9.99609",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganization);
export default __webpack_public_path__ + "static/media/icon_organization.3ae962556b85ee1a342f1918cc4a4665.svg";
export { ForwardRef as ReactComponent };